import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: true,
  status: null,
  message: null,
  data: null,
};
const sectorSupplierReducer = createReducer(initialState, {
  SECTOR_FIND_SUPPLIERS_REQUEST: (state) => {
    state.loading = true;
    state.data = null;
    state.status = null;
    state.message = null;
  },
  SECTOR_FIND_SUPPLIERS_SUCCESS: (state, action) => {
    const payload = action.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = payload.data; // Ensure this is the correct data structure
  },
  SECTOR_FIND_SUPPLIERS_FAILURE: (state, action) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = null;
  },
});

export default sectorSupplierReducer;